import React from 'react';
import { homeObjThree } from './Data';
import { InfoSection } from '../../components';

const SignUp = () => {
    return (
        <div>
            <InfoSection {...homeObjThree} />
        </div>
    )
}

export default SignUp